export default {
  canonicalId: 'https://claims.cimpress.io/canonical_id',
  was: 'https://claims.cimpress.io/was',
  isAnonymous: 'https://claims.cimpress.io/is_anonymous',
  isCustomer: 'https://claims.cimpress.io/is_customer',
  isInternal: 'https://claims.cimpress.io/cimpress_internal',
};
